import { Localized, useLocalization } from "@fluent/react";
import {
    Alert,
    AlertTitle,
    AppBar,
    Badge,
    Button,
    ButtonGroup, Chip, CircularProgress, Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle, FormControlLabel,
    FormGroup,
    Grid,
    IconButton, Paper, SelectChangeEvent,
    Stack,
    Switch,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    TextField, Tooltip,
    Typography,
    Collapse
} from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { Dispatch, SetStateAction, useCallback, useEffect, useMemo, useState } from "react";
import { If } from "../../app/If";
import { APIError, AppId, AppTextFieldHandler } from "../../app/appTypes";
import { showError, showSuccess } from "../notifications/notificationsSlice";
import { Box } from "@mui/system";
import produce from "immer";
import { selectSettings } from '../settings/settingsSlice';
import MenuItem from '@mui/material/MenuItem';
import { ReqCriticalityLabel } from "../urs/ReqCriticalityLabel";
import { LoadingButton, TabContext, TabList, TabPanel } from "@mui/lab";
import { Check, Clear } from "@mui/icons-material";
import { autoMatchOffer, createUrsOfferComment, deleteUrsOfferComment, rejectOffer, RequirementNote, selectAllOfferRequirements, sendOffer, sendToEvaluation, updateUrsOffer, updateUrsOfferComment, UrsOffer, UrsOfferMessage, UrsOfferRequirement, postUrsOfferRequirementNote, assignResponsibleUser, matchRequirementWithOffer, DiscussionType, sendToTeamOpinion, finishOpinion, UrsOfferRequirementStatus, MatchingTargetData, postUrsOfferRequirementSupplierStatus, postUrsOfferRequirementStatus, allURSOfferRequirements, AutoMatchingParameters, loadUrsOffer } from "./ursOfferSlice";
import { NoteLabel } from "./NoteLabel";
import { Comment, CommentKind } from "../../app/Discuss";
import { selectLoggedUserId } from "../user/userSlice";
import { parseISODate } from "../../app/Utils";
import { groupBy } from "../../app/arrays";
import { EntityState, unwrapResult } from "@reduxjs/toolkit";
import DownloadIcon from '@mui/icons-material/Download';
import { useLocation, useSearchParams } from "react-router-dom";
import { UserPicker } from "../users/UserPicker";
import { FullNameByUserId } from "../users/FullName";
import { MatchDoc, OfferFormProps, URSRequirementRowProps } from "./types";
import AttachmentIcon from '@mui/icons-material/Attachment';
import { OfferAttachementsDialog } from "./OfferAttachementsDialog";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import AssessmentIcon from '@mui/icons-material/Assessment';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import CommentIcon from '@mui/icons-material/Comment';
import { useNavigate } from "react-router-dom";
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import { UrsRequestToolbarMenu } from "./utils/UrsRequestToolbarMenu";
import { SupplierUrsOfferHeader } from "./utils/SupplierUrsOfferHeader";
import { OfferTeamMemberPanel } from "./utils/OfferTeamMemberPanel";
import { ManagedTeamMember } from "../utils/managedObject";
import { loadSpec, selectAllSpecs, Spec, SpecWithDetails } from "../specs/specSlice";
import { LoadSpecs } from "../../app/AppDataLoader";
import { LoadingContainer } from "../../app/LoadingContainer";
import { MatchRequirementWithSpec } from "./MatchRequirementWithSpec";
import { Discuss } from "../../app/NewDiscuss";
import { BlobResourceType } from "../documents/blobResourceTypes";
import { loadSupplierDevice } from "../supplierdevices/supplierDeviceSlice";
import { loadSupplierDeviceDetail } from "../supplierdevices/supplierDeviceDetailsSlice";
import MatchingTargetDialog from "./utils/MatchingTargetDialog";
import AutoMatchDialog from "./utils/AutoMatchDialog";
import { ImportedOfferRequirementsFlatPanel } from "./ImportedOfferRequirementsFlatPanel";
import SmallStatusBadge from "../../app/components/SmallStatusBadge";
import { BackgroundProcessSummaryDialog } from "../backgroundProcessing/BackgroundProcessSummaryPanel";
import { PublishLink } from "../urs/PublishLink";
import { loadAccessRequests, PubAccessRequest, setStatusOfAccessRequest } from "../documents/publicAccessApi";
import { ServerErrorMsg } from "../../app/ServerErrorMsg";
import LoginIcon from '@mui/icons-material/Login';
import BlockIcon from '@mui/icons-material/Block';
import { UrsOfferEventHistoryView } from "./utils/UrsOfferEventHistoryView";
import GroupsIcon from "@mui/icons-material/Groups";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { UrsOfferCompleteCommentingDialog } from "./dialogs/UrsOfferCompleteCommentingDialog";
import { updateUrsOfferRequirement } from "./ursOfferRequirementsSlice";
import { Attachements } from "../urs/Attachements";
import { selectBlobsByResourceId } from "../documents/attachementsSlice";
import { Blobs, uploadBlobs, Uuid } from "../documents/attachementsSlice";
import { BlobLink } from "../documents/BlobLink";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { BlobPickerDialog } from "./dialogs/AiFileSelectorDialog";
import { verifyRequirementByAIClient } from "./supplierAiApi";
import { PdfViewer } from "../utils/PdfViewer";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";

type MainTabs = "reqs" | "description" | "attachments" | "team"

const findComponentRef = (matchDoc: MatchDoc | undefined, requirement: UrsOfferRequirement): string => {
    const { deviceComponentId, supplierDeviceDetailId } = requirement

    if (matchDoc === undefined) return ''

    switch (matchDoc.tag) {
        case 'offer':
            if (supplierDeviceDetailId) {
                for (let i = 0; i < matchDoc.deviceDetails.length; i++) {
                    const element = matchDoc.deviceDetails[i];
                    if (element.id == supplierDeviceDetailId) {
                        return element.position.toString()
                    }
                }
            }
            break;
        case 'fds':
            if (deviceComponentId) {
                for (let i = 0; i < matchDoc.spec.components.length; i++) {
                    const element = matchDoc.spec.components[i];
                    if (element.id.toString() === deviceComponentId) {
                        return element.numeration ?? ''
                    }
                }
            }
            break;
        case 'fs&ds':
            break;
    }

    return ''
}

const URSRequirementRow = ({
    requirement,
    onEditClick,
    onApproveClick,
    canEdit,
    canComment,
    onOfferDetailClick,
    onCommentsClick,
    onAssignToClick,
    onAttachementsClick,
    commentsCount,
    offerReference,
    client }: URSRequirementRowProps) => {

    const [approving, setApproving] = useState(false)

    const handleApproveClick = useCallback(async () => {
        setApproving(true)
        try {
            await onApproveClick(requirement)
        } catch (error) {
            console.log(error)
        } finally {
            setApproving(false)
        }
    }, [])

    const blobs = useAppSelector(state => selectBlobsByResourceId(state, requirement.guid))
    const attachementsCount = blobs?.blobs?.length ?? 0
    const offerChip = offerReference ? <Chip variant="outlined" label={`p. ${offerReference}`} /> : <></>

    return <TableRow>
        <TableCell
            sx={{
                paddingRight: requirement.parentRequirementId ? '20px' : '2px',
                textAlign: requirement.parentRequirementId ? 'right' : 'left',
                backgroundColor: requirement.parentRequirementId ? '#fafafa' : 'inherit',
            }}>
            {requirement.numeration}
        </TableCell>
        <TableCell>
            <SmallStatusBadge label={requirement.status} />
            <div
                dangerouslySetInnerHTML={{ __html: requirement.name }}
                style={requirement.status === 'DELETED' ? { textDecoration: 'line-through', color: 'red' } : undefined}
            />
        </TableCell>

        <TableCell>{<ReqCriticalityLabel criticality={requirement.criticality ?? ""} />}</TableCell>
        <TableCell>
            <Badge color="info" badgeContent={attachementsCount} invisible={attachementsCount === 0}>
                <Tooltip title={<Localized id="attachements">Załączniki</Localized>}>
                    <IconButton size="small" onClick={() => onAttachementsClick(requirement)}>
                        <AttachmentIcon />
                    </IconButton>
                </Tooltip>
            </Badge>
        </TableCell>
        <TableCell sx={{ textAlign: "center" }}>
            <NoteLabel note={requirement.note ?? ''} />
        </TableCell>
        <TableCell> {requirement.isAutoMatched && (
            <span
                className="ml-1 px-1 py-0.5 rounded bg-green-200 text-green-800 font-semibold text-sm relative"
                style={{ top: '-5px', fontSize: '0.7rem' }}
            >
                auto
            </span>
        )}{requirement.comment}</TableCell>
        <TableCell>
            {commentsCount === 0 ? (
                <Chip label="Brak dyskusji" color="default" size="small" />
            ) : (
                <Stack direction="column" spacing={0.5}>
                    <Chip
                        label={
                            requirement.commentStatus === 'AGREED'
                                ? 'Klient: zatwierdził'
                                : 'Klient: oczekiwanie'
                        }
                        color={requirement.commentStatus === 'AGREED' ? 'success' : 'warning'}
                        size="small"
                    />
                    <Chip
                        label={
                            requirement.supplierCommentStatus === 'AGREED'
                                ? 'Dostawca: zatwierdził'
                                : 'Dostawca: oczekiwanie'
                        }
                        color={requirement.supplierCommentStatus === 'AGREED' ? 'success' : 'warning'}
                        size="small"
                    />
                </Stack>
            )}
        </TableCell>
        <TableCell>{offerChip}</TableCell>
        <TableCell><FullNameByUserId userId={requirement.responsibleUserId ?? ''}></FullNameByUserId></TableCell>
        <TableCell >
            <ButtonGroup variant="outlined" color="secondary" size="small">
                <If condition={!client && canEdit && requirement.note === ""}>
                    <Tooltip title={<Localized id="urs-offer-action-approve"><span>Approve</span></Localized>}>
                        <IconButton disabled={approving} size="small" onClick={handleApproveClick}
                            sx={{
                                color: 'default',
                                '&:hover': {
                                    color: 'success.main',
                                },
                            }}>
                            <DoneAllIcon />
                        </IconButton>
                    </Tooltip>
                </If>
                <If condition={!client && canEdit}>
                    <Tooltip title={<Localized id="urs-offer-action-rate"><span>Oceń</span></Localized>}>
                        <IconButton size="small" onClick={() => onEditClick(requirement)}>
                            <AssessmentIcon />
                        </IconButton>
                    </Tooltip>
                </If>
                <If condition={!client && canEdit}>
                    <Tooltip title={<Localized id="urs-offer-supplier-device-detail"><span>Offer</span></Localized>}>
                        <IconButton size="small" onClick={() => onOfferDetailClick(requirement)}>
                            <LocalOfferIcon />
                        </IconButton>
                    </Tooltip>
                </If>
                <If condition={!client && canEdit}>
                    <Tooltip title={<Localized id="urs-offer-add-responsible"><span>Assign to</span></Localized>}>
                        <IconButton size="small" onClick={() => onAssignToClick(requirement)}>
                            <PersonAddIcon />
                        </IconButton>
                    </Tooltip>
                </If>
                {commentsCount > 0 &&
                    <Badge color='secondary' badgeContent={commentsCount} invisible={commentsCount === 0}>
                        <Tooltip title={<Localized id="discussion"><span>Dyskusja</span></Localized>}>
                            <IconButton size="small" onClick={() => onCommentsClick(requirement)}>
                                <CommentIcon />
                            </IconButton>
                        </Tooltip>
                    </Badge>
                }

            </ButtonGroup>
        </TableCell>
    </TableRow>

}

type DialogState
    = "none"
    | "addReqComment"
    | "confirmSendOffer"
    | "confirmRejectOffer"
    | "confirmSendToEvaluate"
    | "sendToTeamOpinion"
    | "finishReview"
    | "offerDetail"
    | "selectDevice"
    | "confirmAutoMatch"
    | "comments"
    | "addResponsible"
    | "attachements"
    | "offerTokenDialog"
    | "completeCommentingTask"

export const SuppliersOfferForm = ({ entity, mode, comments, blobs }: OfferFormProps) => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const { l10n } = useLocalization()
    const [draftEntity, setDraftEntity] = useState(entity)
    const { locale } = useAppSelector(selectSettings);
    const currentUserId = useAppSelector(selectLoggedUserId)
    const [params] = useSearchParams()
    const { state } = useLocation() as { state?: { open?: string; nonce?: number } };
    const [tab, setTab] = useState<MainTabs>("reqs")
    const [dialog, setDialog] = useState<DialogState>("none")
    const [actionPending, setActionPending] = useState(false)
    const [discussionType, setDiscussionType] = useState<DiscussionType>('PRIVATE_COMPANY')

    const [showOnlyNonEvaluated, setShowOnlyNonEvaluated] = useState(false)
    const [showAssignedToMe, setAssignedToMe] = useState(false)
    const [showOnlyDiscussed, setShowOnlyDiscussed] = useState(false)
    const [showProcessSummary, setShowProcessSummary] = useState(false)
    const [requirement, setRequirement] = useState<UrsOfferRequirement | null>(null)
    const [offerComment, setOfferComment] = useState("")
    const [internalComments, setInternalComments] = useState<UrsOfferMessage[]>(comments)
    const [specDetails, setSpecDetails] = useState<SpecWithDetails | undefined>(undefined)
    const [matchDoc, setMatchDoc] = useState<MatchDoc | undefined>(undefined)
    const [serverError, setServerError] = useState("")
    const [saving, setSaving] = useState<boolean>(false)
    const [selectedDiscussionSupplierStatus, setSelectedDiscussionSupplierStatus] = useState<UrsOfferRequirementStatus | null>(null);
    const [selectedDiscussionClientStatus, setSelectedDiscussionClientStatus] = useState<UrsOfferRequirementStatus | null>(null);
    const [asignToPromise, setAsignToPromise] = useState<Promise<{ responsibleUserId: AppId }> | undefined>(undefined)

    const allSpecs = useAppSelector(state => selectAllSpecs(state).filter(({ structureId }) => structureId === entity.deviceTypeId))
    const [spec, setSpec] = useState<Spec | undefined>(() => {
        if (entity.deviceSpecificationId) {
            return allSpecs.find(({ id }) => id.toString() === entity.deviceSpecificationId)
        } else {
            return undefined
        }
    })

    const { deviceSpecificationId, supplierDeviceId, fsSpecificationId, dsSpecificationId } = draftEntity

    const isMatchingNotActive = deviceSpecificationId == "" && supplierDeviceId == "" && fsSpecificationId == "" && dsSpecificationId == "";



    const getMatchDocLabel = (matchDoc: MatchDoc): string => {
        switch (matchDoc.tag) {
            case 'offer':
                return matchDoc.device.name;
            case 'fds':
                return matchDoc.spec.name;
            case 'fs&ds':
                return 'FS: ' + matchDoc.fs.name + ' DS: ' + matchDoc.ds.name;

            default:
                return 'Unknown';
        }
    };

    const handleBackgroundProcessCompleted = useCallback(async () => {
        try {
            const refreshedEntity = await dispatch(loadUrsOffer(entity.id)).then(unwrapResult)
            setDraftEntity(refreshedEntity)
            dispatch(showSuccess("refreshed"))
        } catch {
            dispatch(showError('error'))
        } finally {
            setShowProcessSummary(false)
        }
    }, [dispatch, entity.id])


    const [isLoadingMatchDoc, setIsLoadingMatchDoc] = useState(false);

    useEffect(() => {
        if (draftEntity.deviceSpecificationId) {
            console.log(`Loading fds!`)
            setIsLoadingMatchDoc(true);
            const specId = parseInt(draftEntity.deviceSpecificationId)
            dispatch(loadSpec(specId))
                .then(unwrapResult)
                .then(data => setMatchDoc({
                    tag: 'fds',
                    spec: data,
                }))
                .catch(err => {
                    console.log(err)
                })
                .finally(() => setIsLoadingMatchDoc(false))

        } else if (fsSpecificationId && dsSpecificationId) {
            console.log(`Loading fs and ds!`)
            setIsLoadingMatchDoc(true);
            const fsId = parseInt(fsSpecificationId)
            const dsId = parseInt(dsSpecificationId)
            dispatch(loadSpec(fsId))
                .then(unwrapResult)
                .then(fsData => {
                    dispatch(loadSpec(dsId))
                        .then(unwrapResult)
                        .then(dsData => setMatchDoc({
                            tag: 'fs&ds',
                            fs: fsData,
                            ds: dsData,
                        }))
                        .catch(err => {
                            console.log(err)
                        })
                })
                .catch(err => {
                    console.log(err)
                })
                .finally(() => setIsLoadingMatchDoc(false))


        } else if (supplierDeviceId) {
            console.log(`Loading offer (supplier device)!`)
            setIsLoadingMatchDoc(true);
            dispatch(loadSupplierDevice(supplierDeviceId))
                .then(unwrapResult)
                .then(dev => {
                    dispatch(loadSupplierDeviceDetail(dev.id))
                        .then(unwrapResult)
                        .then(det => setMatchDoc({
                            tag: 'offer',
                            device: dev,
                            deviceDetails: det,
                        }))
                        .catch(err => {
                            console.log(err)
                        })
                })
                .catch(err => {
                    console.log(err)
                })
                .finally(() => setIsLoadingMatchDoc(false))
        }
    }, [deviceSpecificationId, supplierDeviceId, fsSpecificationId, dsSpecificationId])

    useEffect(() => {
        if (state?.open === 'comments' && params.has('requirementId')) {
            const paramRequirementId = params.get('requirementId')
            if (paramRequirementId) {
                for (let i = 0; i < entity.types.length; i++) {
                    const t = entity.types[i]
                    for (let n = 0; n < t.requirements.length; n++) {
                        const requirement = t.requirements[n];
                        if (requirement.id === paramRequirementId) {
                            setContextTypeId(t.id)
                            setRequirement(requirement)
                            setDialog('comments')

                        }
                        for (let k = 0; k < requirement.childRequirements.length; k++) {
                            const subRequirement = requirement.childRequirements[k];
                            if (subRequirement.id === paramRequirementId) {
                                setContextTypeId(t.id)
                                setRequirement(subRequirement)
                                setDialog('comments')

                            }
                        }
                    }
                    for (let j = 0; j < t.groups.length; j++) {
                        const g = t.groups[j]
                        for (let m = 0; m < g.requirements.length; m++) {
                            const requirement = g.requirements[m];
                            if (requirement.id === paramRequirementId) {
                                setContextTypeId(t.id)
                                setRequirement(requirement)
                                setDialog('comments')

                            }
                            for (let k = 0; k < requirement.childRequirements.length; k++) {
                                const subRequirement = requirement.childRequirements[k];
                                if (subRequirement.id === paramRequirementId) {
                                    setContextTypeId(t.id)
                                    setRequirement(subRequirement)
                                    setDialog('comments')
                                }
                            }
                        }
                    }
                }
            }
        }
    }, [params, state?.nonce])

    const updateDataLocally = useCallback((f: (data: UrsOffer) => void) => {
        setDraftEntity(produce(draft => {
            f(draft)
        }))
    }, [])
    const updateCommentsLocally = useCallback((f: (cs: UrsOfferMessage[]) => void) => {
        setInternalComments(produce(draft => {
            f(draft)
        }))
    }, [])

    const [contextTypeId, setContextTypeId] =
        useState<AppId | undefined>(entity.types.length > 0 ? entity.types[0].id : undefined)
    const contextType = useMemo(() => draftEntity.types.find(x => x.id === contextTypeId), [contextTypeId, draftEntity.types])

    const handleReqsTabChange = useCallback((_, newType) => {
        setContextTypeId(newType)
    }, [])

    const handleBackButtonClick = useCallback(() => {
        navigate(-1)
    }, [navigate])
    const handleMainTabChange = useCallback((_, newTab) => {
        setTab(newTab)
    }, [])


    const handleMatchRequirementWithOffer = useCallback(async (specComponentId: string | null, deviceDetailId: string | null) => {
        if (requirement !== null) {
            try {
                const result = await dispatch(matchRequirementWithOffer({
                    offerId: entity.id,
                    requirementId: requirement.id,
                    supplierDeviceDetailId: deviceDetailId,
                    deviceComponentId: specComponentId,
                })).unwrap()
                setDraftEntity(result)
                setRequirement(produce(draft => {
                    if (draft) {
                        draft.deviceComponentId = specComponentId
                        draft.supplierDeviceDetailId = deviceDetailId
                    }
                }))
            } catch (err) {
                dispatch(showError("error"))
            }
        }
    }, [requirement])

    const handleDialogCancelClick = useCallback(() => {
        setDialog("none")
    }, [])

    const handleDeviceChange = (event: SelectChangeEvent) => {
        const newDevice = allSpecs.find(({ id }) => id.toString() === event.target.value)
        if (newDevice) {
            setSpec(newDevice)
        }
    }
    const handleSelectDeviceClick = useCallback(() => {
        setDialog("selectDevice")
    }, [])

    const handleChangeMatchingTarget = useCallback(() => {
        setDialog("selectDevice")
    }, [])


    const handleDeviceSelectionConfirm = (data: MatchingTargetData) => {
        setSaving(true)

        dispatch(updateUrsOffer({
            ...draftEntity,
            deviceSpecificationId: data?.fdsId?.toString() ?? null,
            fsSpecificationId: data?.fsId?.toString() ?? null,
            dsSpecificationId: data?.dsId?.toString() ?? null,
            supplierDeviceId: data?.offerId?.toString() ?? null,
        })).then(unwrapResult).then(result => {
            setDraftEntity(result)
            dispatch(showSuccess("saved"))
        }).catch(() => { dispatch(showError("error")) })
            .finally(() => { setDialog("none"); setSaving(false); })
    };

    const handleCancelDeviceSelectionClick = useCallback(() => {
        setDialog("none")
    }, [])

    const handlePrintUrsClick = async () => {
        if (draftEntity.id) {
            window.open(`${process.env.REACT_APP_REST_API}api/reports/urs-offer/${draftEntity.id}?language=${locale}`, '_blank')
        }
    }

    const handleSendOfferClick = async () => {
        setDialog("confirmSendOffer")
    }

    const handleAutoMatchClick = async () => {
        setDialog("confirmAutoMatch")
    }

    const handleRejectOfferClick = async () => {
        setDialog("confirmRejectOffer")
    }

    const handleSendToEvaluateClick = async () => {
        setDialog("confirmSendToEvaluate")
    }

    const handleSendToTeamOpinionClick = async () => {
        setDialog("sendToTeamOpinion")
    }

    const handleCompleteCommentingClick = async () => {
        setDialog("completeCommentingTask")
    }

    const handleFinishReviewClick = async () => {
        setDialog("finishReview")
    }


    const handleOfferCommentChange: AppTextFieldHandler = useCallback(e => setOfferComment(e.target.value), [])

    const handleConfirmSendOfferClick = async () => {
        try {
            const result = await dispatch(sendOffer(draftEntity.id));

            if (sendOffer.fulfilled.match(result)) {
                const updatedEntity = result.payload as UrsOffer;
                setDraftEntity(updatedEntity)
                dispatch(showSuccess("saved"))

            }
            else {
                let errorMsg = "error"
                if (result.payload) {
                    if (result.payload.kind === 'http') {
                        const problem = result.payload.problem
                        if (problem) {
                            errorMsg = problem.title
                        }
                    }
                }
                dispatch(showError(errorMsg))
            }
        }
        catch (error) {
            dispatch(showError("error"))
        }
        setDialog("none")
    }

    const handleStatusChange = async (status) => {
        try {
            setSelectedDiscussionSupplierStatus(status);

            setDraftEntity(
                produce(draft => {
                    if (requirement?.id) {
                        updateRequirementSupplierCommentStatusInDraft(draft, requirement.id, status);
                    }
                })
            );

            await dispatch(postUrsOfferRequirementSupplierStatus(
                {
                    id: draftEntity.id,
                    requirementId: requirement?.id || "",
                    status: status
                })).unwrap()



        } catch (e) {
            console.error("Error updating requirement status:", e);
        }
    };

    const updateRequirementClientStatusInDraft = (
        draft: typeof draftEntity,
        requirementId: string,
        status: UrsOfferRequirementStatus
    ) => {
        for (const mainGr of draft.types) {
            for (const req of mainGr.requirements) {
                if (req.id === requirementId) {
                    req.commentStatus = status;
                }
                if (req.childRequirements) {
                    for (const childReq of req.childRequirements) {
                        if (childReq.id === requirementId) {
                            childReq.commentStatus = status;
                        }
                    }
                }
            }
            for (const group of mainGr.groups) {
                for (const req of group.requirements) {
                    if (req.id === requirementId) {
                        req.commentStatus = status;
                    }
                    if (req.childRequirements) {
                        for (const childReq of req.childRequirements) {
                            if (childReq.id === requirementId) {
                                childReq.commentStatus = status;
                            }
                        }
                    }
                }
            }
        }
    };

    const updateRequirementSupplierCommentStatusInDraft = (
        draft: typeof draftEntity,
        requirementId: string,
        status: UrsOfferRequirementStatus
    ) => {
        for (const mainGr of draft.types) {
            for (const req of mainGr.requirements) {
                if (req.id === requirementId) {
                    req.supplierCommentStatus = status;
                }
                if (req.childRequirements) {
                    for (const childReq of req.childRequirements) {
                        if (childReq.id === requirementId) {
                            childReq.supplierCommentStatus = status;
                        }
                    }
                }
            }
            for (const group of mainGr.groups) {
                for (const req of group.requirements) {
                    if (req.id === requirementId) {
                        req.supplierCommentStatus = status;
                    }
                    if (req.childRequirements) {
                        for (const childReq of req.childRequirements) {
                            if (childReq.id === requirementId) {
                                childReq.supplierCommentStatus = status;
                            }
                        }
                    }
                }
            }
        }
    };
    const handleConfirmRejectOfferClick = async () => {

        try {

            const updatedEntity = await dispatch(rejectOffer({ offerId: draftEntity.id, comment: offerComment })).unwrap()
            setDraftEntity(updatedEntity)
            dispatch(showSuccess("saved"))
        } catch (error) {
            dispatch(showError("error"))
        }
        setDialog("none")

    }

    const handleConfirmAutoMatchClick = async (parameters: AutoMatchingParameters) => {
        try {
            setSaving(true)

            const result = await dispatch(autoMatchOffer({
                offerId: draftEntity.id,
                parameters
            }))

            if (autoMatchOffer.fulfilled.match(result)) {
                setDialog("none")
                setShowProcessSummary(true)
            } else {

                let errorMsg = "error"

                if (result.payload && result.payload.kind === 'http') {
                    const problem = result.payload.problem

                    if (problem) {
                        errorMsg = problem.title
                        setServerError(errorMsg)
                    }
                }
                else {
                    dispatch(showError("error"))
                }
            }

        } catch (error) {
            setDialog("none")

            dispatch(showError("error"))
        }
        finally {
            setSaving(false)
        }
    }

    const handleConfirmSendToTeamOpinionClick = async () => {
        setSaving(true)

        try {
            const result = await dispatch(sendToTeamOpinion(draftEntity.id))
            if (sendToTeamOpinion.fulfilled.match(result)) {
                const updatedEntity = result.payload as UrsOffer;
                setDraftEntity(updatedEntity)
                dispatch(showSuccess("saved"))
                setDialog("none")

            } else {
                let errorMsg = "error"
                if (result.payload && result.payload.kind === 'http') {
                    const problem = result.payload.problem
                    if (problem) {
                        errorMsg = problem.title

                    }
                }
                setServerError(errorMsg)
            }

        } catch (error) {
            dispatch(showError("error"))
        }
        finally {
            setSaving(false)
        }
    }


    const handleCompleteCommenting = (entity: UrsOffer) => {
        if (entity) {
            setDraftEntity(entity)
        }
        setDialog("none")
    }

    const handleConfirmFinishReviewClick = async () => {
        setSaving(true)

        try {
            const result = await dispatch(finishOpinion(draftEntity.id))
            if (finishOpinion.fulfilled.match(result)) {
                const updatedEntity = result.payload as UrsOffer;
                setDraftEntity(updatedEntity)
                dispatch(showSuccess("saved"))
                setDialog("none")

            } else {
                let errorMsg = "error"
                if (result.payload && result.payload.kind === 'http') {
                    const problem = result.payload.problem
                    if (problem) {
                        errorMsg = problem.title

                    }
                }
                setServerError(errorMsg)
            }

        } catch (error) {
            dispatch(showError("error"))
        }
        finally {
            setSaving(false)
        }
    }

    const handleConfirmSendToEvaluateClick = async (msg: string) => {
        try {

            const updatedEntity = await dispatch(sendToEvaluation({ offerId: draftEntity.id, comment: msg })).unwrap()
            setDraftEntity(updatedEntity)
            dispatch(showSuccess("saved"))
        } catch (error) {
            dispatch(showError("error"))
        }
        setDialog("none")

    }


    const handleEditRequirementClick = useCallback((requirement: UrsOfferRequirement) => {
        setRequirement(requirement)
        setSelectedDiscussionSupplierStatus(requirement?.supplierCommentStatus)
        setSelectedDiscussionClientStatus(requirement?.commentStatus)
        setDialog("addReqComment")
    }, [])

    const handleApproveClick = useCallback(async (updatedRequirement: UrsOfferRequirement) => {
        setActionPending(true)
        try {
            const result = await dispatch(postUrsOfferRequirementNote({
                id: entity.id,
                requirementId: updatedRequirement.id,
                comment: updatedRequirement.comment,
                note: 'F',
            })).unwrap()

            setDraftEntity(
                produce(draft => {
                    for (const mainGr of draft.types) {
                        for (const req of mainGr.requirements) {
                            if (req.id === updatedRequirement.id) {
                                req.note = 'F'
                                req.isAutoMatched = false
                            }
                            if (req.childRequirements) {
                                for (const childReq of req.childRequirements) {
                                    if (childReq.id === updatedRequirement.id) {
                                        childReq.note = 'F'
                                        childReq.isAutoMatched = false
                                    }
                                }
                            }
                        }
                        for (const group of mainGr.groups) {
                            for (const req of group.requirements) {
                                if (req.id === updatedRequirement.id) {
                                    req.note = 'F'
                                    req.isAutoMatched = false
                                }
                                if (req.childRequirements) {
                                    for (const childReq of req.childRequirements) {
                                        if (childReq.id === updatedRequirement.id) {
                                            childReq.note = 'F'
                                            childReq.isAutoMatched = false
                                        }
                                    }
                                }
                            }
                        }
                    }
                }))
        } catch (error) {
            console.log(error)
        } finally {
            setActionPending(false)
        }
    }, [])

    const handleSelectOfferDetailClick = useCallback((requirement: UrsOfferRequirement) => {
        setRequirement(requirement)
        setDialog("offerDetail")
    }, [])
    const handleCommentsClick = useCallback((requirement: UrsOfferRequirement) => {
        setRequirement(requirement)
        setSelectedDiscussionClientStatus(requirement.commentStatus)
        setSelectedDiscussionSupplierStatus(requirement?.supplierCommentStatus)
        setDialog("comments")
    }, [])
    const handleAssignToClick = useCallback((requirement: UrsOfferRequirement) => {
        const promise = new Promise<{ responsibleUserId: AppId }>((resolve, reject) => { })
        setAsignToPromise(promise)
        setRequirement(requirement)
        setPersonResponsible(requirement.responsibleUserId ?? '')
        setDialog("addResponsible")
    }, [])
    const [personResponsible, setPersonResponsible] = useState<AppId>("")

    const handleAttachementsClick = useCallback((requirement: UrsOfferRequirement) => {
        setRequirement(requirement)
        setDialog('attachements')
    }, [])

    const publicComments = useMemo(() => {
        return internalComments.filter(({ ursRequirementId, discussionType }) => ursRequirementId.toString() === requirement?.id && discussionType === 'INTER_COMPANY').map(({ id, message, author, parentMessageId, userId, companyName, date, guid, type }) => {
            return {
                someId: id,
                content: message,
                author: author ?? "Bez nazwy",
                parentId: parentMessageId,
                authorId: userId,
                companyName: companyName,
                date: parseISODate(date),
                guid,
                kind: type,
            } as Comment
        })
    }, [requirement, internalComments])

    const privateComments = useMemo(() => {
        return internalComments.filter(({ ursRequirementId, discussionType }) => ursRequirementId.toString() === requirement?.id && discussionType === 'PRIVATE_COMPANY').map(({ id, message, author, parentMessageId, userId, companyName, date, guid, type }) => {
            return {
                someId: id,
                content: message,
                author: author ?? "Bez nazwy",
                parentId: parentMessageId,
                authorId: userId,
                companyName: companyName,
                date: parseISODate(date),
                guid,
                kind: type,
            } as Comment
        })
    }, [requirement, internalComments])

    const postComment = async (message: string, parentCommentId: AppId | null, kind: CommentKind, files: File[] | null = null): Promise<Uuid | undefined> => {
        if (requirement !== null) {
            try {
                const newComment = await dispatch(createUrsOfferComment({
                    id: "",
                    ursOfferId: entity.id,
                    ursRequirementId: requirement.id,
                    message,
                    author: "",
                    companyName: "",
                    userId: currentUserId,
                    date: new Date().toISOString(),
                    parentMessageId: parentCommentId,
                    status: "",
                    guid: '',
                    discussionType,
                    type: kind,
                })).unwrap()

                await dispatch(postUrsOfferRequirementStatus({
                    id: draftEntity.id,
                    requirementId: requirement.id,
                    status: 'AWAITING'
                })).unwrap();
                setSelectedDiscussionClientStatus('AWAITING');

                setDraftEntity(
                    produce(draft => {
                        if (requirement?.id) {
                            updateRequirementClientStatusInDraft(draft, requirement.id, 'AWAITING');
                        }
                    })
                );

                if (files !== null && newComment.guid) {
                    await dispatch(uploadBlobs([newComment.guid, files, { resourceType: BlobResourceType.UrsOfferMessage, parentResourceId: entity.ursGuid, parentResourceType: BlobResourceType.Document }])).unwrap()
                }
                setInternalComments(produce(draft => {
                    draft.push(newComment)
                }))
                return newComment.guid
            } catch (e) {
                /* handle error */
                console.log(e)
            }
        }
    }

    const updateComment = async (commentId: AppId, message: string) => {
        const comment = internalComments.find(x => x.id === commentId)
        if (requirement !== null && comment) {
            try {
                const newComment = await dispatch(updateUrsOfferComment({
                    ...comment,
                    message,
                })).unwrap()
                setInternalComments(produce(draft => {
                    const i = draft.findIndex(x => x.id === commentId)
                    if (i >= 0) {
                        draft[i] = newComment
                    }
                }))
            } catch (e) {
                /* handle error */
                console.log(e)
            }
        }
    }

    const onSuccessfullAddTeamMember = (teamMember: ManagedTeamMember) => {
        setDraftEntity(produce(draft => {
            draft.managedTeamMembers.push(teamMember)
        }))
    };

    const onSuccessfullChangeOwner = (updateOffer: UrsOffer) => {
        setDraftEntity(updateOffer)
    };

    const deleteComment = async (id: AppId) => {
        try {
            await dispatch(deleteUrsOfferComment(id)).unwrap()
            setInternalComments(oldComments => oldComments.filter(comment => comment.id !== id))
        } catch (e) {
            /* handle error */
            console.log(e)
        }
    }

    const handleShowOnlyNonevaluatedChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setShowOnlyNonEvaluated(event.target.checked);
    }
    const handleShowOnlyDiscussedChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setShowOnlyDiscussed(event.target.checked);
    }
    const handleShowAssignedToMeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAssignedToMe(event.target.checked);
    }

    const editable = (draftEntity.actions?.contentActions?.some(action => action === "EDIT")) && mode !== "preview"
    const canComment = (draftEntity.actions?.contentActions?.some(action => action === "COMMENT")) && mode !== "preview"
    const hasWorkflowAction = (actionName) => draftEntity.actions?.workflowActions?.includes(actionName) || false;
    const hasContentAction = (actionName) => draftEntity.actions?.contentActions?.includes(actionName) || false;

    const groupedComments = groupBy(internalComments, x => x.ursRequirementId ?? x.ursOfferId)

    const isRowVisible: (requirement: UrsOfferRequirement) => boolean = useCallback((requirement) => {
        return (showOnlyDiscussed ? groupedComments[requirement.id]?.length > 0 : true)
            && (showOnlyNonEvaluated ? (requirement.note === null || requirement.note === '') : true)
    }, [showOnlyDiscussed, showOnlyNonEvaluated, groupedComments])
    const [panelOpen, setPanelOpen] = useState(true);
    const goNext = useCallback((req: UrsOfferRequirement) => {
        const gen = allURSOfferRequirements(draftEntity, isRowVisible)
        let result = gen.next()
        while (result.value !== undefined && result.value.id !== req.id && result.done === false) {
            result = gen.next()
        }
        if (result.done === false) {
            result = gen.next()
            if (result.value) {
                setRequirement(result.value)
            }
        }
    }, [draftEntity, isRowVisible])

    const handleGoNextClick = () => {
        if (requirement) {
            goNext(requirement)
        }
    }

    if (contextTypeId === undefined || contextType === undefined) return <div>Nothing to display</div>

    let matchTitle = ''
    if (matchDoc?.tag === 'offer') {
        matchTitle = `Match requirement with offer: ${matchDoc.device.name}`
    }
    else if (matchDoc?.tag === 'fds') {
        matchTitle = `Match requirement with FDS no: ${matchDoc.spec.name}`
    }
    else if (matchDoc?.tag === 'fs&ds') {
        matchTitle = `Match requirement with FS no : ${matchDoc.fs.name} and DS no: ${matchDoc.ds.name}`
    }

    const imported = entity.metadata !== null

    return <LoadSpecs component={<LoadingContainer />}>
        <Container sx={{
            height: 'calc(100vh - 150px)',
        }} component="div" maxWidth={false} >
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <SupplierUrsOfferHeader ursOffer={draftEntity}></SupplierUrsOfferHeader>
                </Grid>
                {<Grid item xs={6} sx={{ paddingTop: "10px!important" }}>
                    <If condition={isLoadingMatchDoc == false} otherwise={
                        <CircularProgress />
                    }>
                        {!isMatchingNotActive && matchDoc &&
                            <Alert severity="info">
                                <AlertTitle>
                                    <Localized id="urs-offer-supplier-current-matching-target">_matching to</Localized>
                                    <span> {`${matchDoc.tag.toUpperCase()}: `}</span>


                                </AlertTitle>
                                {`${getMatchDocLabel(matchDoc)}`}
                                <Button sx={{ marginLeft: 2 }} onClick={handleChangeMatchingTarget} variant='outlined' size="small">
                                    <Localized id="change">Zmień</Localized>
                                </Button>
                            </Alert>
                        }
                        {isMatchingNotActive &&
                            <Alert severity="warning">
                                <AlertTitle>
                                    <Localized id="urs-offer-supplier-no-matching-target">_no matching target</Localized>
                                    <Button sx={{ marginLeft: 2 }} onClick={handleChangeMatchingTarget} variant='outlined' size="small">
                                        <Localized id="choose">Zmień</Localized>
                                    </Button>
                                </AlertTitle>
                            </Alert>
                        }
                    </If>
                </Grid>}
                <Grid item xs={6} sx={{ paddingTop: "10px!important" }}>
                    <div className='flex flex-row-reverse'>
                        <FormGroup row>
                            <FormControlLabel control={
                                <Switch checked={showAssignedToMe}
                                    onChange={handleShowAssignedToMeChange} />}
                                label={<Localized id="urs-offer-show-assigned-to-me">Przypisane do mnie</Localized>}
                            />
                            <FormControlLabel control={
                                <Switch checked={showOnlyNonEvaluated}
                                    onChange={handleShowOnlyNonevaluatedChange} />}
                                label={<Localized id="urs-offer-show-only-not-evaluated">Pokaż tylko nieocenione</Localized>}
                            />
                            <FormControlLabel control={
                                <Switch
                                    checked={showOnlyDiscussed}
                                    onChange={handleShowOnlyDiscussedChange} />}
                                label={<Localized id="urs-offer-show-only-discussed">Pokaż tylko dyskutowane</Localized>}
                            />
                        </FormGroup>
                    </div>
                </Grid>
                <Grid item xs={12} sx={{ paddingTop: "10px!important" }}>
                    <TabContext value={tab}>
                        <TabList onChange={handleMainTabChange}>
                            <Tab
                                key={0}
                                value="reqs"
                                label={<Localized id="urs-requirements">Lista wymagań</Localized>} />
                            <Tab
                                key={1}
                                value="description"
                                label={<Localized id="urs-purpose-and-description">Cel i opis</Localized>} />
                            {/* <Tab
                                key={2}
                                value="attachments"
                                label={<Localized id="urs-attachements">Załączniki-URS</Localized>} /> */}
                            <Tab
                                key={2}
                                value="private-attachments"
                                label={<Localized id="">Private attachmets</Localized>} />
                            <Tab
                                key={3}
                                value="team"
                                label={<Localized id="team">Team</Localized>} />
                            <Tab
                                key={4}
                                value="publish"
                                label={'Publish'} />
                        </TabList>
                        <TabPanel value="reqs">
                            <If condition={!imported} otherwise={<ImportedOfferRequirementsFlatPanel
                                urs={draftEntity}
                                template={false}
                                comments={internalComments}
                                assignTo={handleAssignToClick}
                                updateComments={updateCommentsLocally}
                                onlyNotEvaluated={showOnlyNonEvaluated}
                                showComments={handleCommentsClick}
                                assignedToMe={showAssignedToMe}
                            />}>
                                <Box sx={{
                                    display: 'flex',
                                    flexGrow: 1,
                                }}>
                                    <Tabs
                                        orientation="vertical"
                                        variant="standard"
                                        value={contextTypeId}
                                        onChange={handleReqsTabChange}
                                        sx={{
                                            borderRight: 1,
                                            borderColor: 'divider',
                                        }}
                                    >
                                        {Array.from(draftEntity.types, t => <Tab
                                            key={t.id}
                                            label={t.code || t.name}
                                            value={t.id}
                                        />)}
                                    </Tabs>
                                    <Stack sx={{
                                        paddingLeft: 4,
                                        width: '100%',
                                    }} direction="column" spacing={2}>
                                        <Typography variant="subtitle2">
                                            <If condition={contextTypeId !== undefined}
                                                otherwise={<></>}
                                            >{`${contextType.numeration} ${contextType.code} ${contextType.name}`}</If>
                                        </Typography>
                                        <TableContainer sx={{ maxHeight: 'calc(100vh - 460px)' }} component={Paper}> <Table stickyHeader>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ minWidth: 100, width: 100, maxWidth: 100 }}>
                                                        <Typography component="span" variant="subtitle2" color="textSecondary">
                                                            <Localized id="urs-item-lp">Lp</Localized>
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography component="span" variant="subtitle2" color="textSecondary">
                                                            <Localized id="urs-item-name">Nazwa</Localized>
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell sx={{ minWidth: 120, width: 120, maxWidth: 120 }}>
                                                        <Typography component="span" variant="subtitle2" color="textSecondary">
                                                            <Localized id="urs-item-criticality">Krytyczność</Localized>
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell sx={{ minWidth: 120, width: 120, maxWidth: 120 }}>
                                                        <Typography component="span" variant="subtitle2" color="textSecondary">
                                                            <Localized id="urs-attachements">Załączniki</Localized>
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell sx={{ minWidth: 100, width: 100, maxWidth: 100, textAlign: "center" }}>
                                                        <Typography component="span" variant="subtitle2" color="textSecondary">
                                                            <Localized id="urs-offer-note">Ocena</Localized>
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell sx={{ minWidth: 200 }}>
                                                        <Typography component="span" variant="subtitle2" color="textSecondary">
                                                            <Localized id="urs-offer-comment">Komentarz</Localized>
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography component="span" variant="subtitle2" color="textSecondary">
                                                            <Localized id="urs-offer-discussion-status">Client status</Localized>
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography component="span" variant="subtitle2" color="textSecondary">
                                                            <Localized id="urs-offer-detail">Offer detail</Localized>
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography component="span" variant="subtitle2" color="textSecondary">
                                                            <Localized id="urs-offer-assigned-to">Assigned to</Localized>
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell sx={{ justifyContent: 'flex-end' }}></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>

                                                {contextType.requirements.map(requirement => !isRowVisible(requirement) ? null :
                                                    <>
                                                        <URSRequirementRow
                                                            key={requirement.id}
                                                            requirement={requirement}
                                                            onEditClick={handleEditRequirementClick}
                                                            onApproveClick={handleApproveClick}
                                                            offerStatus={draftEntity.status}
                                                            canEdit={editable}
                                                            canComment={canComment}
                                                            onOfferDetailClick={handleSelectOfferDetailClick}
                                                            onCommentsClick={handleCommentsClick}
                                                            onAssignToClick={handleAssignToClick}
                                                            onAttachementsClick={handleAttachementsClick}
                                                            commentsCount={groupedComments[requirement.id]?.length ?? 0}
                                                            client={mode === "preview"}
                                                            offerReference={findComponentRef(matchDoc, requirement)}
                                                        />
                                                        {requirement.childRequirements.map(childReq =>
                                                            <URSRequirementRow
                                                                key={childReq.id}
                                                                requirement={childReq}
                                                                onEditClick={handleEditRequirementClick}
                                                                onApproveClick={handleApproveClick}
                                                                offerStatus={draftEntity.status}
                                                                canEdit={editable}
                                                                canComment={canComment}
                                                                onOfferDetailClick={handleSelectOfferDetailClick}
                                                                onCommentsClick={handleCommentsClick}
                                                                onAssignToClick={handleAssignToClick}
                                                                onAttachementsClick={handleAttachementsClick}
                                                                commentsCount={groupedComments[childReq.id]?.length ?? 0}
                                                                client={mode === "preview"}
                                                                offerReference={findComponentRef(matchDoc, childReq)}
                                                            />
                                                        )}
                                                    </>
                                                )
                                                }
                                                {contextType.groups.map(group =>
                                                    <>
                                                        <TableRow sx={{ bgcolor: '#f1f1f1' }}>
                                                            <TableCell colSpan={9}>{`${group.numeration} ${group.name}`}</TableCell>
                                                        </TableRow>
                                                        {group.requirements.map(
                                                            requirement => !isRowVisible(requirement) ? null :
                                                                <>
                                                                    <URSRequirementRow
                                                                        key={requirement.id}
                                                                        requirement={requirement}
                                                                        onEditClick={handleEditRequirementClick}
                                                                        onApproveClick={handleApproveClick}
                                                                        offerStatus={draftEntity.status}
                                                                        canEdit={editable}
                                                                        canComment={canComment}
                                                                        onOfferDetailClick={handleSelectOfferDetailClick}
                                                                        onCommentsClick={handleCommentsClick}
                                                                        onAssignToClick={handleAssignToClick}
                                                                        onAttachementsClick={handleAttachementsClick}
                                                                        commentsCount={groupedComments[requirement.id]?.length ?? 0}
                                                                        offerReference={findComponentRef(matchDoc, requirement)}
                                                                        client={mode === "preview"}
                                                                    />
                                                                    {requirement.childRequirements.map(childReq =>
                                                                        <URSRequirementRow
                                                                            key={childReq.id}
                                                                            requirement={childReq}
                                                                            onEditClick={handleEditRequirementClick}
                                                                            onApproveClick={handleApproveClick}
                                                                            offerStatus={draftEntity.status}
                                                                            canEdit={editable}
                                                                            canComment={canComment}
                                                                            onOfferDetailClick={handleSelectOfferDetailClick}
                                                                            onCommentsClick={handleCommentsClick}
                                                                            onAssignToClick={handleAssignToClick}
                                                                            onAttachementsClick={handleAttachementsClick}
                                                                            commentsCount={groupedComments[childReq.id]?.length ?? 0}
                                                                            offerReference={findComponentRef(matchDoc, childReq)}
                                                                            client={mode === "preview"}
                                                                        />
                                                                    )}
                                                                </>
                                                        )
                                                        }
                                                    </>
                                                )}
                                            </TableBody>
                                        </Table>
                                        </TableContainer>
                                    </Stack>
                                </Box>
                            </If>
                        </TabPanel>
                        <TabPanel value="description" sx={{ height: 'calc(100vh - 450px)', overflowY: 'auto' }}>
                            <Stack direction="column" spacing={4} >
                                <Box>
                                    <Typography variant="h5" component="h5" gutterBottom>
                                        <Localized id="urs-title"><span>Tytuł dokumentu</span></Localized>
                                    </Typography>
                                    <div>{draftEntity.title}</div>
                                </Box>
                                <Box>
                                    <Typography variant="h5" component="h5" gutterBottom>
                                        <Localized id="urs-purpose"><span>Cel</span></Localized>
                                    </Typography>
                                    <div dangerouslySetInnerHTML={{ __html: draftEntity.purpose }} />
                                </Box>
                                <Box>
                                    <Typography variant="h5" component="h5" gutterBottom>
                                        <Localized id="urs-description"><span>Opis</span></Localized>
                                    </Typography>
                                    <div dangerouslySetInnerHTML={{ __html: draftEntity.description }} />
                                </Box>
                                <Box>
                                    <Typography variant="h5" component="h5" gutterBottom>
                                        <Localized id="urs-area"><span>Obszar działania</span></Localized>
                                    </Typography>
                                    <div dangerouslySetInnerHTML={{ __html: draftEntity.area }} />
                                </Box>
                            </Stack>
                        </TabPanel>
                        {/* <TabPanel value="attachments">
                            <AttachmentsTable blobs={blobs} requirements={entity.ursOfferRequirements} />
                        </TabPanel> */}
                        <TabPanel value="private-attachments">
                            <Attachements resourceId={entity.guid} resourceType={BlobResourceType.UrsOffer} parentResourceId={entity.ursGuid} parentResourceType={BlobResourceType.Document} canDelete={true} canUpload={true} />
                        </TabPanel>
                        <TabPanel value="team">
                            <OfferTeamMemberPanel
                                offerId={draftEntity.id}
                                editable={hasContentAction("TEAM")}
                                teamMembers={draftEntity.managedTeamMembers}
                                onSuccessfullAddTeamMember={onSuccessfullAddTeamMember}
                                onSuccessfullChangeOwner={onSuccessfullChangeOwner}
                            />
                        </TabPanel>
                        <TabPanel value="publish">
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, bgcolor: 'var(--gray-50)', p: 2 }}>
                                {/* <Paper sx={{ p: 2 }}>
                                    <h3>Private link</h3>
                                    <PrivateLink ursId={entity.id} />
                                </Paper> */}
                                <Paper sx={{ p: 2 }}>
                                    <h3>Public link</h3>
                                    <PublishOfferPanel docId={entity.id} />
                                </Paper>
                                <UrsOfferEventHistoryView documentId={entity.id} />
                            </Box>
                        </TabPanel>
                    </TabContext>
                </Grid>
                <Grid item xs={12}>

                </Grid>
            </Grid>
            <AppBar position="fixed" color="transparent" sx={{ top: 'auto', bottom: 0, p: 0.5 }}>
                <div className="flex justify-end">
                    <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
                        <ButtonGroup variant="contained" color="secondary">
                            <Button color="error" onClick={() => handleRejectOfferClick()} variant="outlined" style={{ display: hasWorkflowAction("RESIGN") ? "inline" : "none" }}>
                                <Localized id="urs-offer-action-reject">
                                    <span>Zrezygnuj</span>
                                </Localized>
                            </Button>
                            <Button color="primary" onClick={() => handleSendToEvaluateClick()} variant="outlined" style={{ display: hasWorkflowAction("SEND_TO_EVALUATION") ? "inline" : "none" }}>
                                <Localized id="urs-offer-action-send-to-evaluation">
                                    <span>Wyślij do oceny</span>
                                </Localized>
                            </Button>
                            <Button color="primary" onClick={() => handleSendToTeamOpinionClick()} variant="outlined" style={{ display: hasWorkflowAction("SEND_TO_OPINION") ? "inline" : "none" }}>
                                <Localized id="urs-offer-action-send-for-team-input">
                                    <span>Wyślij do zespołu</span>
                                </Localized>
                            </Button>
                            <Button color="primary" onClick={() => handleCompleteCommentingClick()} variant="outlined" style={{ display: hasWorkflowAction("URS_REQUEST_RESPONSIBLE_COMMENT") ? "inline" : "none" }}>
                                <Localized id="urs-offer-action-comment-requirement-task">
                                    <span>Wprowadzono komentarze</span>
                                </Localized>
                            </Button>
                            <Button onClick={() => handleSendOfferClick()} color="secondary" variant="outlined" style={{ display: hasWorkflowAction("FINISH_COMMENTING") ? "inline" : "none" }}>
                                <Localized id="urs-offer-action-send-offer">
                                    <span>Złóż ofertę</span>
                                </Localized>
                            </Button>
                            <Button onClick={() => handleFinishReviewClick()} color="secondary" variant="outlined" style={{ display: hasWorkflowAction("FINISH_REVIEW") ? "inline" : "none" }}>
                                <Localized id="urs-offer-action-finish-process">
                                    <span>Finish opinion</span>
                                </Localized>
                            </Button>

                            <Button onClick={() => handleAutoMatchClick()} color="secondary" variant="outlined" style={{ display: hasContentAction("EDIT") ? "inline" : "none" }}>
                                <Localized id="urs-offer-auto-matching">
                                    <span>Auto - matching</span>
                                </Localized>
                            </Button>
                        </ButtonGroup>
                    </Box>
                    <UrsRequestToolbarMenu usrRequestId={draftEntity.id} usrId={draftEntity.ursId} />

                    <Button variant='contained' color="primary" size="small" onClick={handleBackButtonClick}>
                        <Localized id='back'>Wróć</Localized>
                    </Button>
                </div>
            </AppBar>
            {dialog === "addReqComment" && requirement !== null && <EvaluateRequirement
                offerId={entity.id}
                requirement={requirement}
                privateComments={privateComments}
                publicComments={publicComments}
                discussionType={discussionType}
                setDiscussionType={setDiscussionType}
                update={updateDataLocally}
                updateComments={updateCommentsLocally}
                onSuccess={() => setDialog('none')}
                onCancel={() => setDialog('none')}
                docUUID={entity.guid}
                ursGuid={entity.ursGuid}
                goNext={goNext}
            />}
            <Dialog open={dialog === "finishReview"}>
                <DialogContent>
                    <DialogTitle>
                        <Localized id="">
                            <span>Do you want to finish opinion?</span>
                        </Localized>
                    </DialogTitle>

                    {
                        serverError && <Alert sx={{ marginTop: 1, }} onClose={() => { setServerError("") }} severity="error">
                            <Localized id={serverError}>
                                <span>Server error</span>
                            </Localized>
                        </Alert>
                    }
                </DialogContent>
                <DialogActions>
                    <LoadingButton loading={saving} onClick={handleConfirmFinishReviewClick}>
                        <Localized id="yes"><span>Tak</span></Localized>
                    </LoadingButton>
                    <LoadingButton loading={saving} onClick={handleDialogCancelClick}>
                        <Localized id="no"><span>Nie</span></Localized>
                    </LoadingButton>
                </DialogActions>
            </Dialog>
            <Dialog open={dialog === "sendToTeamOpinion"}>
                <DialogContent>
                    <DialogTitle>
                        <Localized id="urs-offer-action-send-for-team-input">
                            <span>Czy wysłać do skomentowania?</span>
                        </Localized>
                    </DialogTitle>
                    <Alert severity="info">
                        <Localized id="urs-offer-action-send-for-team-input-descripton">
                            <span>Evaluation</span>
                        </Localized>
                    </Alert>
                    {
                        serverError && <Alert sx={{ marginTop: 1, }} onClose={() => { setServerError("") }} severity="error">
                            <Localized id={serverError}>
                                <span>Server error</span>
                            </Localized>
                        </Alert>
                    }
                </DialogContent>
                <DialogActions>
                    <LoadingButton loading={saving} onClick={handleConfirmSendToTeamOpinionClick}>
                        <Localized id="yes"><span>Tak</span></Localized>
                    </LoadingButton>
                    <LoadingButton loading={saving} onClick={handleDialogCancelClick}>
                        <Localized id="no"><span>Nie</span></Localized>
                    </LoadingButton>
                </DialogActions>
            </Dialog>
            {dialog === "completeCommentingTask" &&
                <UrsOfferCompleteCommentingDialog
                    ursOfferId={draftEntity.id}
                    onSave={handleCompleteCommenting}
                    onCancel={handleDialogCancelClick}
                />
            }
            {dialog === "confirmSendToEvaluate" &&
                <SendToEvaluateDialog
                    documentId={draftEntity.id}
                    ok={handleConfirmSendToEvaluateClick}
                    cancel={handleDialogCancelClick}
                />
            }
            {showProcessSummary && (
                <BackgroundProcessSummaryDialog
                    open={showProcessSummary}
                    onClose={() => setShowProcessSummary(false)}
                    objectType="URS_OFFER"
                    objectId={draftEntity.id}
                    onCompleted={handleBackgroundProcessCompleted}
                />
            )}
            {dialog === "confirmAutoMatch" &&
                <AutoMatchDialog
                    serverError={serverError}
                    saving={saving}
                    setServerError={setServerError}
                    handleConfirmAutoMatchClick={handleConfirmAutoMatchClick}
                    handleDialogCancelClick={handleDialogCancelClick}
                />
            }
            {/* <Dialog open={dialog === "confirmAutoMatch"}>
                <DialogContent>
                    <DialogTitle>
                        <Localized id="urs-offer-matching-question">
                            <span>Czy chcesz aby system zaproponował powiązania między wymaganiami o ofertą?</span>
                        </Localized>
                    </DialogTitle>
                    <Alert severity="info">
                        <Localized id="urs-offer-matching-question-description">
                            <span>Auto matching</span>
                        </Localized>
                    </Alert>
                </DialogContent>
                {
                    serverError && <Alert sx={{ marginTop: 1, }} onClose={() => { setServerError("") }} severity="error">
                        <Localized id={serverError}>
                            <span>Server error</span>
                        </Localized>
                    </Alert>
                }
                <DialogActions>
                    <LoadingButton loading={saving} onClick={handleConfirmAutoMatchClick}>
                        <Localized id="yes"><span>Tak</span></Localized>
                    </LoadingButton>
                    <LoadingButton loading={saving} onClick={handleDialogCancelClick}>
                        <Localized id="no"><span>Nie</span></Localized>
                    </LoadingButton>
                </DialogActions>
            </Dialog> */}
            <Dialog open={dialog === "confirmSendOffer"}>
                <DialogTitle>
                    <Localized id="urs-offer-action-send-offer-question">
                        <span>Czy napewno zakończyć komentowanie</span>
                    </Localized>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Alert severity="info">
                            <Localized id="urs-offer-action-send-offer-question-description">
                                <span>Zakończenie komentowania?</span>
                            </Localized>
                        </Alert>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleConfirmSendOfferClick}>
                        <Localized id="yes"><span>Tak</span></Localized>
                    </Button>
                    <Button onClick={handleDialogCancelClick}>
                        <Localized id="no"><span>Nie</span></Localized>
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={dialog === "confirmRejectOffer"}>
                <DialogContent>
                    <DialogTitle>
                        <Localized id="urs-offer-action-resign-question">
                            <span>Czy napewno zrezygnować ze składania oferty?</span>
                        </Localized>
                    </DialogTitle>
                    <Alert severity="info">
                        <Localized id="urs-offer-action-resign-question-description">
                            <span>Czy napewno zrezygnować ze składania oferty?</span>
                        </Localized>
                    </Alert>
                    <TextField
                        multiline
                        rows={5}
                        onChange={handleOfferCommentChange}
                        value={offerComment}
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        sx={{ marginTop: "20px", width: "100%" }}
                        label={<Localized id="urs-offer-comment"><span>Komentarz</span></Localized>}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleConfirmRejectOfferClick}>
                        <Localized id="resign"><span>Resign</span></Localized>
                    </Button>
                    <Button onClick={handleDialogCancelClick}>
                        <Localized id="cancel"><span>Nie</span></Localized>
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={dialog === "offerDetail"} fullWidth fullScreen>
                <DialogTitle>{matchTitle}</DialogTitle>
                <DialogContent>
                    {requirement && matchDoc && <MatchRequirementWithSpec
                        requirement={requirement}
                        publicComments={publicComments}
                        privateCommenst={privateComments}
                        matchDoc={matchDoc}
                        match={handleMatchRequirementWithOffer}
                    />}
                </DialogContent>
                <DialogActions>


                    <Button onClick={handleDialogCancelClick}>
                        <Localized id="close"><span>Close</span></Localized>
                    </Button>
                </DialogActions>
            </Dialog>
            {
                <Dialog open={dialog === 'selectDevice'} fullWidth maxWidth="md">
                    <MatchingTargetDialog
                        draftEntity={draftEntity}
                        onClose={handleCancelDeviceSelectionClick}
                        onConfirm={(data) => handleDeviceSelectionConfirm(data)}
                        saving={saving} />
                </Dialog>
            }
            <Dialog open={dialog === 'comments'} fullWidth maxWidth='lg'>
                <DialogTitle sx={{
                    display: 'flex',
                    gap: 2,
                }}>
                    <Localized id="comments"><span>Komentarze</span></Localized>
                    <Chip variant='outlined' label={requirement?.numeration ?? ''} />
                </DialogTitle>
                <DialogContent>
                    <Stack spacing={2}>
                        <Typography variant="subtitle2"
                            dangerouslySetInnerHTML={{ __html: requirement?.name ?? '' }} >
                        </Typography>
                        <If condition={requirement !== null && requirement.comment !== ""}>
                            <Alert variant='outlined' severity="info">{requirement?.comment ?? ""}</Alert>
                        </If>
                        <Paper variant="outlined" sx={{ p: 1, borderRadius: 2, overflow: "hidden" }}>
                            <Box sx={{

                                display: "flex", alignItems: "center", justifyContent: "space-between",
                                bgcolor: "background.paper"
                            }}>
                                <Typography variant="subtitle2" fontWeight={700}>Dyskusja</Typography>
                                <IconButton
                                    onClick={() => setPanelOpen(o => !o)}
                                    aria-expanded={panelOpen}
                                    aria-label={panelOpen ? "Zwiń panel" : "Rozwiń panel"}
                                    size="small"
                                >
                                    <ExpandMoreIcon
                                        sx={{
                                            transition: "transform .2s",
                                            transform: panelOpen ? "rotate(180deg)" : "rotate(0deg)"
                                        }}
                                    />
                                </IconButton>
                            </Box>
                            <Collapse in={panelOpen} timeout="auto" unmountOnExit>
                                <Box
                                    sx={{
                                        position: "sticky",
                                        top: 0,
                                        zIndex: 2,
                                        bgcolor: "background.paper",
                                        mb: 1.5,
                                        pt: 0.5,
                                    }}
                                >
                                    <Tabs
                                        value={discussionType}
                                        onChange={(_, v) => setDiscussionType(v)}
                                        variant="fullWidth"
                                        aria-label="Wybierz wątek dyskusji"
                                        sx={{
                                            border: 1,
                                            borderColor: "divider",
                                            borderRadius: 1.5,
                                            minHeight: 42,
                                            "& .MuiTabs-flexContainer": { gap: 0.5, p: 0.5 },
                                            "& .MuiTab-root": {
                                                minHeight: 36,
                                                textTransform: "none",
                                                fontWeight: 600,
                                                borderRadius: 1,
                                                color: "text.secondary",
                                                "&.Mui-selected": {
                                                    color: "primary.main",
                                                    bgcolor: "action.selected",
                                                },
                                            },
                                            "& .MuiTabs-indicator": { display: "none" },
                                        }}
                                    >
                                        <Tab
                                            value="PRIVATE_COMPANY"
                                            icon={<GroupsIcon sx={{ fontSize: 18 }} />}
                                            iconPosition="start"
                                            label={
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                    <span>Dyskusja zespołu</span>
                                                    <Badge
                                                        color="secondary"
                                                        sx={{ marginLeft: '5px' }}
                                                        badgeContent={privateComments.length}
                                                        max={99}
                                                        invisible={!privateComments.length}
                                                    />
                                                </Box>
                                            }
                                        />
                                        <Tab
                                            value="INTER_COMPANY"
                                            icon={<HandshakeOutlinedIcon sx={{ fontSize: 18 }} />}
                                            iconPosition="start"
                                            label={
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                    <span>Dyskusja z klientem</span>
                                                    <Badge
                                                        color="secondary"
                                                        sx={{ marginLeft: '5px' }}
                                                        badgeContent={publicComments.length}
                                                        max={99}
                                                        invisible={!publicComments.length}
                                                    />
                                                </Box>
                                            }
                                        />
                                    </Tabs>
                                </Box>

                                {discussionType === "PRIVATE_COMPANY" ? (
                                    <Alert
                                        severity="info"
                                        sx={{ mb: 2, borderRadius: 2 }}
                                    >
                                        This is a private discussion, not visible to the client.
                                    </Alert>
                                ) : (
                                    <Alert
                                        severity="warning"
                                        sx={{ mb: 2, borderRadius: 2 }}
                                    >
                                        This is a public discussion, visible to the client. Please write carefully.
                                    </Alert>
                                )}

                                <Box >
                                    {discussionType === "PRIVATE_COMPANY" ? (
                                        <Discuss
                                            allComments={privateComments}
                                            postComment={postComment}
                                            updateComment={updateComment}
                                            deleteComment={deleteComment}
                                            currentUserId={currentUserId}
                                            readOnly={draftEntity.status === "F"}
                                            docUUID={entity.guid}
                                            resourceType={BlobResourceType.UrsOffer}
                                            parentResourceId={entity.ursGuid}
                                            parentResourceType={BlobResourceType.Document}
                                        />
                                    ) : (
                                        <Discuss
                                            allComments={publicComments}
                                            postComment={postComment}
                                            updateComment={updateComment}
                                            deleteComment={deleteComment}
                                            currentUserId={currentUserId}
                                            readOnly={draftEntity.status === "F"}
                                            docUUID={entity.guid}
                                            resourceType={BlobResourceType.UrsOffer}
                                            parentResourceId={entity.ursGuid}
                                            parentResourceType={BlobResourceType.Document}
                                        />
                                    )}
                                </Box>
                            </Collapse>
                        </Paper>

                    </Stack>
                </DialogContent>
                <DialogActions sx={{ flexDirection: 'column', gap: 2 }}>
                    {/* <Paper elevation={2} sx={{ width: '100%', p: 2 }}>
                        <Grid container spacing={2} alignItems="center" justifyContent="space-between" flexWrap="wrap">

                            <Grid item xs={12} md="auto">
                                <Stack spacing={1} direction="row" flexWrap="wrap">
                                    {selectedDiscussionClientStatus === 'AGREED' && (
                                        <Alert severity="success" variant="outlined" sx={{ py: 0.5, px: 1.5, fontSize: '0.85rem' }}>
                                            Klient: zatwierdził
                                        </Alert>
                                    )}
                                    {selectedDiscussionClientStatus === 'AWAITING' && (
                                        <Alert severity="warning" variant="outlined" sx={{ py: 0.5, px: 1.5, fontSize: '0.85rem' }}>
                                            Klient: oczekiwanie na zatwierdzenie
                                        </Alert>
                                    )}
                                    {selectedDiscussionSupplierStatus === 'AWAITING' && (
                                        <Alert severity="warning" variant="outlined" sx={{ py: 0.5, px: 1.5, fontSize: '0.85rem' }}>
                                            Dostawca: oczekiwanie na zatwierdzenie
                                        </Alert>
                                    )}
                                    {selectedDiscussionSupplierStatus === 'AGREED' && (
                                        <Alert severity="success" variant="outlined" sx={{ py: 0.5, px: 1.5, fontSize: '0.85rem' }}>
                                            Dostawca: zatwierdził
                                        </Alert>
                                    )}
                                </Stack>
                            </Grid>

                            <Grid item xs={12} md="auto">
                                <Button
                                    variant={selectedDiscussionSupplierStatus === 'AGREED' ? 'contained' : 'outlined'}
                                    color={selectedDiscussionSupplierStatus === 'AGREED' ? 'success' : 'inherit'}
                                    onClick={() =>
                                        handleStatusChange(selectedDiscussionSupplierStatus === 'AGREED' ? null : 'AGREED')
                                    }
                                    startIcon={
                                        selectedDiscussionSupplierStatus === 'AGREED' ? <CheckBox /> : <CheckBoxOutlineBlank />
                                    }
                                    size="medium"
                                >
                                    {selectedDiscussionSupplierStatus === 'AGREED' ? (
                                        <Localized id="status-agreed-confirmed">Zatwierdzono ustalenia</Localized>
                                    ) : (
                                        <Localized id="status-agreed">Zatwierdzam ustalenia</Localized>
                                    )}
                                </Button>
                            </Grid>
                        </Grid>
                    </Paper> */}
                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Button onClick={handleGoNextClick}>
                            <Localized id="next">Dalej</Localized>
                        </Button>
                        <Button onClick={handleDialogCancelClick}>
                            <Localized id="close">Zamknij</Localized>
                        </Button>
                    </Box>
                </DialogActions>
            </Dialog>
            <Dialog open={dialog === 'addResponsible'} fullWidth maxWidth='md'>
                <DialogTitle>
                    <Localized id='urs-offer-add-responsible'>Assign requirement to another person for assessment</Localized>
                </DialogTitle>
                <DialogContent>
                    <UserPicker sx={{ marginTop: 1 }} value={personResponsible} onChange={user => setPersonResponsible(user?.id ?? '')} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={async () => {
                        try {
                            const offer = await dispatch(assignResponsibleUser({
                                offerId: entity.id,
                                requirementId: requirement?.id ?? "",
                                userId: personResponsible,
                            })).unwrap()
                            setDraftEntity(offer)
                            setDialog('none')
                            if (requirement) {
                                dispatch(updateUrsOfferRequirement({
                                    ...requirement,
                                    responsibleUserId: personResponsible,
                                }))
                            }
                        } catch (e) {
                            console.log(e)
                            dispatch(showError('error'))
                        }
                    }}>
                        <Localized id='ok'>OK</Localized>
                    </Button>
                    <Button onClick={() => { setDialog('none') }}>
                        <Localized id='cancel'>Cancel</Localized>
                    </Button>
                </DialogActions>
            </Dialog>
            {dialog === 'attachements' && <OfferAttachementsDialog

                onClose={() => { setDialog('none') }}
                requirement={requirement}
                ursGuid={draftEntity.ursGuid}
                canUpload={false}
                canDelete={false}
            />
            }
        </Container>

    </LoadSpecs >
}

const AttachmentsTable = ({ blobs, requirements }: { blobs: Blobs[], requirements: EntityState<UrsOfferRequirement> }) => {
    const [heads, ...items] = blobs ?? []
    const headBlobs = heads?.blobs ?? []
    const allRequirements = selectAllOfferRequirements(requirements)
    return <TableContainer>
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell sx={{ width: '50%' }}></TableCell>
                    <TableCell></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {headBlobs.map(blob => {
                    return <TableRow key={blob.blobId}>
                        <TableCell colSpan={2}>
                            <BlobLink blobId={blob.blobId} target="_blank">
                                <IconButton><DownloadIcon /></IconButton>
                            </BlobLink>&nbsp;{blob.fileMeta.fileName}
                        </TableCell>
                    </TableRow>
                })}
                {items.map(({ resourceId, blobs }) => {
                    if (blobs === null || blobs.length === 0) {
                        return null
                    } else {
                        const requirement = allRequirements.find(x => x.guid === resourceId)
                        const [blob0, ...rest] = blobs
                        return [blob0].map(blob => {
                            return <TableRow key={blob.blobId}>
                                <TableCell>
                                    <BlobLink blobId={blob.blobId} target="_blank">
                                        <IconButton><DownloadIcon /></IconButton>
                                    </BlobLink>&nbsp;{blob.fileMeta.fileName}
                                </TableCell>
                                <TableCell rowSpan={blobs.length}>{requirement?.name ?? ""}</TableCell>
                            </TableRow>
                        }).concat(rest.map(blob => {
                            return <TableRow key={blob.blobId}>
                                <TableCell>
                                    <BlobLink blobId={blob.blobId} target="_blank">
                                        <IconButton><DownloadIcon /></IconButton>
                                    </BlobLink>&nbsp;{blob.fileMeta.fileName}
                                </TableCell>
                            </TableRow>
                        }))
                    }
                })}
            </TableBody>
        </Table>
    </TableContainer>
}

interface EvaluateRequirementProps {
    offerId: AppId
    requirement: UrsOfferRequirement
    privateComments: Comment[]
    publicComments: Comment[]
    discussionType: DiscussionType
    setDiscussionType: Dispatch<SetStateAction<DiscussionType>>
    update: (f: (data: UrsOffer) => void) => void
    updateComments: (f: (comments: UrsOfferMessage[]) => void) => void
    onSuccess: () => void
    onCancel: () => void
    docUUID: string
    /** GUID of the owning URS document (the offer's company-bearing parent). */
    ursGuid: string
    goNext: (req: UrsOfferRequirement) => void
}
function EvaluateRequirement(props: EvaluateRequirementProps) {
    const { offerId, requirement, privateComments, publicComments, discussionType, setDiscussionType, update, docUUID, ursGuid, goNext } = props
    const dispatch = useAppDispatch()

    const currentUserId = useAppSelector(selectLoggedUserId)

    const [reqNote, setReqNote] = useState<RequirementNote | null>(requirement.note)
    const [reqComment, setReqComment] = useState(requirement.comment)
    const [actionPending, setActionPending] = useState(false)
    const [selectedDiscussionSupplierStatus, setSelectedDiscussionSupplierStatus] = useState<UrsOfferRequirementStatus | null>(requirement.supplierCommentStatus ?? null);
    const [selectedDiscussionClientStatus, setSelectedDiscussionClientStatus] = useState<UrsOfferRequirementStatus | null>(requirement.commentStatus ?? null);
    const [anyChange, setAnyChange] = useState(false)
    const [panelOpen, setPanelOpen] = useState(true);
    const handleReqCommentChange: AppTextFieldHandler = useCallback(e => {
        setReqComment(e.target.value)
        setAnyChange(true)
    }, [])
    const handleReqCommentStatusChange: AppTextFieldHandler = useCallback(e => {
        setReqNote(e.target.value as RequirementNote)
        setAnyChange(true)
    }, [])

    const { blobs } = useAppSelector(state => selectBlobsByResourceId(state, docUUID) ?? { docUUID, blobs: [] })


    const [askAiOpen, setAskAiOpen] = useState(false);

    const [aiNote, setAiNote] = useState<string>("");
    const [aiAnswer, setAiAnswer] = useState<string>("");
    const [aiLoading, setAiLoading] = useState(false);

    const [blobPickerOpen, setBlobPickerOpen] = useState(false);
    const [selectedBlobId, setSelectedBlobId] = useState<string | null>(null);

    const hasBlobs = !!blobs?.length;

    const selectedBlob = blobs?.find(b => b.blobId === selectedBlobId);
    const selectedBlobName = selectedBlob?.fileMeta.fileName ?? "No file selected";
    const isPdfSelected = selectedBlob?.fileMeta.contentType === "application/pdf";

    const openBlobPicker = () => setBlobPickerOpen(true);
    const closeBlobPicker = () => setBlobPickerOpen(false);

    const handleChangeSelectedBlob = (blobId: string) => {
        setSelectedBlobId(blobId);
    };

    const fileUrl = selectedBlob
        ? `https://vchainer-api.pmtsoftware.eu/blobs/${docUUID}/${selectedBlob.blobId}`
        : undefined;

    const pdfViewer = useMemo(() => {
        if (!selectedBlob || !isPdfSelected || !fileUrl) return null;

        return <PdfViewer fileUrl={fileUrl} locationHint={aiAnswer} />;
    }, [selectedBlob, isPdfSelected, fileUrl, aiAnswer]);

    const handleAskAi = async () => {
        if (!selectedBlobId) {
            return;
        }

        try {
            setAiLoading(true);

            const result = await dispatch(
                verifyRequirementByAIClient({
                    ursRequestId: offerId,
                    fileId: selectedBlobId,
                    requirement: requirement.name ?? "",
                })
            ).unwrap();


            setAiNote(result.note ?? "No answer from AI.");
            setAiAnswer(result.comment ?? "No answer from AI.");
        } catch (err) {
            console.error(err);

        } finally {
            setAiLoading(false);
        }
    };
    const save = async () => {
        if (requirement) {
            setActionPending(true)
            try {
                await dispatch(postUrsOfferRequirementNote({
                    id: offerId,
                    requirementId: requirement.id,
                    comment: reqComment,
                    note: reqNote,
                })).unwrap()
                update(draft => {
                    for (const mainGr of draft.types) {
                        for (const req of mainGr.requirements) {
                            if (req.id === requirement.id) {
                                req.comment = reqComment
                                req.note = reqNote
                                req.isAutoMatched = false
                            }
                            if (req.childRequirements) {
                                for (const childReq of req.childRequirements) {
                                    if (childReq.id === requirement.id) {
                                        childReq.comment = reqComment;
                                        childReq.note = reqNote;
                                        childReq.isAutoMatched = false

                                    }
                                }
                            }
                        }
                        for (const group of mainGr.groups) {
                            for (const req of group.requirements) {
                                if (req.id === requirement.id) {
                                    req.comment = reqComment
                                    req.note = reqNote
                                    req.isAutoMatched = false
                                }
                                if (req.childRequirements) {
                                    for (const childReq of req.childRequirements) {
                                        if (childReq.id === requirement.id) {
                                            childReq.comment = reqComment;
                                            childReq.note = reqNote;
                                            childReq.isAutoMatched = false
                                        }
                                    }
                                }
                            }
                        }
                    }
                })
                setAnyChange(false)
            } catch (error) {
                console.log(error)
            } finally {
                setActionPending(false)
            }
        }
    }

    const handleNextClick = async () => {
        if (anyChange) {
            await save()
        }
        setAiAnswer("")
        setAiNote("")
        goNext(requirement)
    }

    const handleCloseClick = async () => {
        if (anyChange) {
            await save()
        }
        props.onSuccess()
    }

    const postComment = async (message: string, parentCommentId: AppId | null, kind: CommentKind, files: File[] | null = null): Promise<Uuid | undefined> => {
        if (requirement !== null) {
            try {
                const newComment = await dispatch(createUrsOfferComment({
                    id: "",
                    ursOfferId: offerId,
                    ursRequirementId: requirement.id,
                    message,
                    author: "",
                    companyName: "",
                    userId: currentUserId,
                    date: new Date().toISOString(),
                    parentMessageId: parentCommentId,
                    status: "",
                    guid: '',
                    discussionType,
                    type: kind,
                })).unwrap()
                if (files !== null && newComment.guid) {
                    await dispatch(uploadBlobs([newComment.guid, files, { resourceType: BlobResourceType.UrsOfferMessage, parentResourceId: ursGuid, parentResourceType: BlobResourceType.Document }])).unwrap()
                }
                props.updateComments(draft => {
                    draft.push(newComment)
                })
                return newComment.guid
            } catch (e) {
                /* handle error */
                console.log(e)
            }
        }
    }

    const updateComment = async (commentId: AppId, message: string) => {
        const comment = discussionType === 'PRIVATE_COMPANY' ?
            privateComments.find(x => x.someId === commentId) :
            publicComments.find(x => x.someId === commentId)

        if (requirement !== null && comment) {
            try {
                const newComment = await dispatch(updateUrsOfferComment({
                    id: comment.someId,
                    message,
                    parentMessageId: comment.parentId,
                    userId: comment.authorId,
                    guid: comment.guid,
                    type: comment.kind,
                    ursOfferId: offerId,
                    ursRequirementId: requirement.id,
                    author: "",
                    companyName: "",
                    date: new Date().toISOString(),
                    status: "",
                    discussionType,
                })).unwrap()
                props.updateComments(draft => {
                    const i = draft.findIndex(x => x.id === commentId)
                    if (i >= 0) {
                        draft[i] = newComment
                    }
                })
            } catch (e) {
                /* handle error */
                console.log(e)
            }
        }
    }

    const deleteComment = async (id: AppId) => {
        try {
            await dispatch(deleteUrsOfferComment(id)).unwrap()
            props.updateComments(draft => {
                return draft.filter(comment => comment.id !== id)
            })
        } catch (e) {
            /* handle error */
            console.log(e)
        }
    }

    const handleStatusChange = async (status) => {
        try {
            setSelectedDiscussionSupplierStatus(status);

            update(
                draft => {
                    if (requirement?.id) {
                        for (const mainGr of draft.types) {
                            for (const req of mainGr.requirements) {
                                if (req.id === requirement.id) {
                                    req.supplierCommentStatus = status;
                                }
                                if (req.childRequirements) {
                                    for (const childReq of req.childRequirements) {
                                        if (childReq.id === requirement.id) {
                                            childReq.supplierCommentStatus = status;
                                        }
                                    }
                                }
                            }
                            for (const group of mainGr.groups) {
                                for (const req of group.requirements) {
                                    if (req.id === requirement.id) {
                                        req.supplierCommentStatus = status;
                                    }
                                    if (req.childRequirements) {
                                        for (const childReq of req.childRequirements) {
                                            if (childReq.id === requirement.id) {
                                                childReq.supplierCommentStatus = status;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                })
                ;

            await dispatch(postUrsOfferRequirementSupplierStatus(
                {
                    id: offerId,
                    requirementId: requirement?.id || "",
                    status: status
                })).unwrap()



        } catch (e) {
            console.error("Error updating requirement status:", e);
        }
    };

    return <Dialog open={true} fullScreen>
        <DialogTitle
            sx={{
                display: 'flex',
                flexDirection: 'column', // <- ustawiamy kolumnę
                gap: 1,
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                }}
            >
                <Localized id="urs-offer-evaluation-title">
                    <span>Wprowadź ocenę wymagania</span>
                </Localized>
                <Chip variant="outlined" label={requirement.numeration ?? ''} />
            </Box>

            <Paper
                variant="outlined"
                sx={(theme) => ({
                    p: 1,
                    borderRadius: 2,
                    bgcolor: 'action.hover',
                    borderLeft: `4px solid ${theme.palette.primary.main}`,
                })}
            >
                <Typography
                    sx={{
                        lineHeight: 1.5,
                        m: 0,
                        '& p': {
                            margin: 0,
                        },
                        '& ul, &ol': {
                            marginBlock: 0,
                        },
                    }}
                    variant="subtitle1"
                    dangerouslySetInnerHTML={{ __html: requirement.name ?? '' }}
                />
            </Paper>
        </DialogTitle>

        <DialogContent dividers>
            <Grid container spacing={4}>
                <Grid item xs={12} md={5}>
                    <Grid container spacing={3} direction="column">

                        <Grid item>
                            <Paper
                                variant="outlined"
                                sx={{
                                    height: "100%",
                                    borderRadius: 2,
                                }}
                            >
                                <Box
                                    sx={(theme) => ({
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        px: 2,
                                        py: 1,
                                        bgcolor: theme.palette.action.hover,
                                        borderTopLeftRadius: 8,
                                        borderTopRightRadius: 8,
                                    })}
                                >
                                    <Typography
                                        sx={{ fontWeight: 700 }}
                                    >
                                        Your comment
                                    </Typography>
                                </Box>

                                <Box
                                    sx={{
                                        p: 2,
                                        pt: 1.5,
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 2,
                                    }}
                                >
                                    <TextField
                                        value={reqNote}
                                        fullWidth
                                        select
                                        size="small"
                                        label={
                                            <Localized id="urs-offer-req-opinion">
                                                <span>Ocena</span>
                                            </Localized>
                                        }
                                        onChange={handleReqCommentStatusChange}
                                    >
                                        <MenuItem
                                            value={"F"}
                                            sx={{ display: "flex", alignItems: "center", gap: 1 }}
                                        >
                                            <Check fontSize="small" color="success" sx={{ position: "relative", top: 1 }} />
                                            <Localized id="urs-offer-req-f">
                                                <span> Spełnia</span>
                                            </Localized>
                                        </MenuItem>

                                        <MenuItem
                                            value={"U"}
                                            sx={{ display: "flex", alignItems: "center", gap: 1 }}
                                        >
                                            <Clear fontSize="small" color="error" sx={{ position: "relative", top: 1 }} />
                                            <Localized id="urs-offer-req-u">
                                                <span> Nie spełnia</span>
                                            </Localized>
                                        </MenuItem>

                                        <MenuItem
                                            value={"D"}
                                            sx={{ display: "flex", alignItems: "center", gap: 1 }}
                                        >
                                            <QuestionMarkIcon fontSize="small" color="warning" sx={{ position: "relative", top: 1 }} />
                                            <Localized id="urs-offer-req-d">
                                                <span> Do oceny</span>
                                            </Localized>
                                        </MenuItem>
                                    </TextField>

                                    <TextField
                                        fullWidth
                                        multiline
                                        minRows={5}
                                        inputProps={{ maxLength: 1000 }}
                                        value={reqComment}
                                        onChange={handleReqCommentChange}
                                        label={
                                            <Localized id="urs-offer-req-comment">
                                                <span>Komentarz</span>
                                            </Localized>
                                        }
                                    />
                                </Box>
                            </Paper>
                        </Grid>
                        <Grid item>
                            <Paper
                                variant="outlined"
                                sx={{
                                    height: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    borderRadius: 2,
                                }}
                            >
                                {/* Nagłówek */}
                                <Box
                                    sx={(theme) => ({
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        gap: 1,
                                        px: 2,
                                        py: 0.75,
                                        bgcolor: theme.palette.action.hover,
                                        borderTopLeftRadius: 8,
                                        borderTopRightRadius: 8,
                                    })}
                                >
                                    <Typography sx={{ fontWeight: 700 }}>
                                        AI suggestion
                                    </Typography>

                                    <Button
                                        variant="contained"
                                        color="info"
                                        size="small"
                                        startIcon={
                                            aiLoading ? (
                                                <CircularProgress size={16} />
                                            ) : (
                                                <AutoAwesomeIcon fontSize="small" />
                                            )
                                        }
                                        onClick={handleAskAi}
                                        disabled={aiLoading || !selectedBlobId}
                                    >
                                        Ask AI
                                    </Button>
                                </Box>

                                <Box
                                    sx={{
                                        p: 2,
                                        pt: 1.5,
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 1.5,
                                        flex: 1,
                                    }}
                                >
                                    <Box
                                        sx={(theme) => ({
                                            px: 1,
                                            py: 0.5,
                                            borderRadius: 1,
                                            border: `1px solid ${theme.palette.divider}`,
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                        })}
                                    >
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{ whiteSpace: "nowrap" }}
                                        >
                                            Selected file:
                                        </Typography>

                                        <Typography
                                            variant="body2"
                                            noWrap
                                            sx={{ fontWeight: 500, flex: 1, minWidth: 0 }}
                                            title={selectedBlobName}
                                        >
                                            {hasBlobs ? selectedBlobName : "No attachments available"}
                                        </Typography>

                                        <Button
                                            size="small"
                                            variant="outlined"
                                            color="primary"
                                            onClick={openBlobPicker}
                                            disabled={!hasBlobs}
                                        >
                                            Change
                                        </Button>
                                    </Box>

                                    {!selectedBlobId && hasBlobs && (
                                        <Typography
                                            variant="caption"
                                            color="warning.main"
                                        >
                                            Select a file to use Ask AI.
                                        </Typography>
                                    )}

                                    {!hasBlobs && (
                                        <Alert severity="warning">
                                            No attachments available for this document.
                                        </Alert>
                                    )}

                                    {/* AI note */}
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                        }}
                                    >
                                        <Typography variant="caption" >
                                            AI note
                                        </Typography>

                                        <Box
                                            sx={(theme) => ({
                                                px: 1,
                                                py: 0.25,
                                                borderRadius: 1,
                                                bgcolor: "action.hover",
                                                border: `1px solid ${theme.palette.divider}`,
                                                minWidth: 60,
                                            })}
                                        >
                                            <Typography
                                                variant="body2"
                                                sx={{ fontWeight: 500, fontSize: "0.8rem" }}
                                            >
                                                {aiNote || "—"}
                                            </Typography>
                                        </Box>
                                    </Box>

                                    {/* AI answer */}
                                    <TextField
                                        fullWidth
                                        multiline
                                        minRows={4}
                                        label="AI answer"
                                        value={aiAnswer}
                                        InputProps={{ readOnly: true }}
                                        InputLabelProps={{ shrink: true }}

                                    />
                                </Box>
                            </Paper>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={7}>
                    <Paper
                        variant="outlined"
                        sx={{
                            height: "100%",
                            borderRadius: 2,
                            p: 1,
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        {isPdfSelected && pdfViewer}

                        {!isPdfSelected && (
                            <Box
                                flex={1}
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                justifyContent="center"
                                textAlign="center"
                                gap={1}
                            >
                                {selectedBlob ? (
                                    <InsertDriveFileOutlinedIcon sx={{ fontSize: 48, opacity: 0.4 }} />
                                ) : (
                                    <PictureAsPdfOutlinedIcon sx={{ fontSize: 48, opacity: 0.4 }} />
                                )}

                                <Typography variant="subtitle1">
                                    {selectedBlob ? "Preview not available" : "No file selected"}
                                </Typography>

                                <Typography variant="body2" color="text.secondary">
                                    {selectedBlob
                                        ? "Preview is available only for PDF files."
                                        : "Select a file from the list to view the preview."}
                                </Typography>
                            </Box>
                        )}
                    </Paper>
                </Grid>

                <Grid item xs={12}>
                    <Paper variant="outlined" sx={{ p: 1, borderRadius: 2, overflow: "hidden" }}>
                        <Box sx={{

                            display: "flex", alignItems: "center", justifyContent: "space-between",
                            bgcolor: "background.paper"
                        }}>
                            <Typography variant="subtitle2" fontWeight={700}>Discussion</Typography>
                            <IconButton
                                onClick={() => setPanelOpen(o => !o)}
                                aria-expanded={panelOpen}
                                aria-label={panelOpen ? "Collapse panel" : "Expand panel"}
                                size="small"
                            >
                                <ExpandMoreIcon
                                    sx={{
                                        transition: "transform .2s",
                                        transform: panelOpen ? "rotate(180deg)" : "rotate(0deg)"
                                    }}
                                />
                            </IconButton>
                        </Box>
                        <Collapse in={panelOpen} timeout="auto" unmountOnExit>
                            <Box
                                sx={{
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 2,
                                    bgcolor: "background.paper",
                                    mb: 1.5,
                                    pt: 0.5,
                                }}
                            >
                                <Tabs
                                    value={discussionType}
                                    onChange={(_, v) => setDiscussionType(v)}
                                    variant="fullWidth"
                                    aria-label="Wybierz wątek dyskusji"
                                    sx={{
                                        border: 1,
                                        borderColor: "divider",
                                        borderRadius: 1.5,
                                        minHeight: 42,
                                        "& .MuiTabs-flexContainer": { gap: 0.5, p: 0.5 },
                                        "& .MuiTab-root": {
                                            minHeight: 36,
                                            textTransform: "none",
                                            fontWeight: 600,
                                            borderRadius: 1,
                                            color: "text.secondary",
                                            "&.Mui-selected": {
                                                color: "primary.main",
                                                bgcolor: "action.selected",
                                            },
                                        },
                                        "& .MuiTabs-indicator": { display: "none" },
                                    }}
                                >
                                    <Tab
                                        value="PRIVATE_COMPANY"
                                        icon={<GroupsIcon sx={{ fontSize: 18 }} />}
                                        iconPosition="start"
                                        label={
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                <span>Team discussion</span>
                                                <Badge
                                                    color="secondary"
                                                    sx={{ marginLeft: '5px' }}
                                                    badgeContent={privateComments.length}
                                                    max={99}
                                                    invisible={!privateComments.length}
                                                />
                                            </Box>
                                        }
                                    />
                                    <Tab
                                        value="INTER_COMPANY"
                                        icon={<HandshakeOutlinedIcon sx={{ fontSize: 18 }} />}
                                        iconPosition="start"
                                        label={
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                <span>Discussion with client</span>
                                                <Badge
                                                    color="secondary"
                                                    sx={{ marginLeft: '5px' }}
                                                    badgeContent={publicComments.length}
                                                    max={99}
                                                    invisible={!publicComments.length}
                                                />
                                            </Box>
                                        }
                                    />
                                </Tabs>
                            </Box>

                            {discussionType === "PRIVATE_COMPANY" ? (
                                <Alert
                                    severity="info"
                                    sx={{ mb: 2, borderRadius: 2 }}
                                >
                                    <Localized id="discussion-private-warning">
                                        This is a private discussion, not visible to the client.
                                    </Localized>
                                </Alert>
                            ) : (
                                <Alert
                                    severity="warning"
                                    sx={{ mb: 2, borderRadius: 2 }}
                                >
                                    <Localized id="discussion-public-warning">
                                        This is a public discussion, visible to the client. Please write carefully.
                                    </Localized>
                                </Alert>
                            )}

                            <Box >
                                {discussionType === "PRIVATE_COMPANY" ? (
                                    <Discuss
                                        allComments={privateComments}
                                        postComment={postComment}
                                        updateComment={updateComment}
                                        deleteComment={deleteComment}
                                        currentUserId={currentUserId}
                                        showTitle={true}
                                        multiThread={true}
                                        readOnly={false}
                                        docUUID={docUUID}
                                        resourceType={BlobResourceType.UrsOffer}
                                        parentResourceId={ursGuid}
                                        parentResourceType={BlobResourceType.Document}
                                    />
                                ) : (
                                    <Discuss
                                        allComments={publicComments}
                                        postComment={postComment}
                                        updateComment={updateComment}
                                        deleteComment={deleteComment}
                                        currentUserId={currentUserId}
                                        showTitle={true}
                                        readOnly={false}
                                        docUUID={docUUID}
                                        resourceType={BlobResourceType.UrsOffer}
                                        parentResourceId={ursGuid}
                                        parentResourceType={BlobResourceType.Document}
                                    />
                                )}
                            </Box>
                        </Collapse>
                    </Paper>

                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            {/* <Paper elevation={2} sx={{ width: '100%', p: 2 }}>
                <Grid container spacing={2} alignItems="center" justifyContent="space-between" flexWrap="wrap">

                    <Grid item xs={12} md="auto">
                        <Stack spacing={1} direction="row" flexWrap="wrap">
                            {selectedDiscussionClientStatus === 'AGREED' && (
                                <Alert severity="success" variant="outlined" sx={{ py: 0.5, px: 1.5, fontSize: '0.85rem' }}>
                                    Klient: zatwierdził
                                </Alert>
                            )}
                            {selectedDiscussionClientStatus === 'AWAITING' && (
                                <Alert severity="warning" variant="outlined" sx={{ py: 0.5, px: 1.5, fontSize: '0.85rem' }}>
                                    Klient: oczekiwanie na zatwierdzenie
                                </Alert>
                            )}
                            {selectedDiscussionSupplierStatus === 'AWAITING' && (
                                <Alert severity="warning" variant="outlined" sx={{ py: 0.5, px: 1.5, fontSize: '0.85rem' }}>
                                    Dostawca: oczekiwanie na zatwierdzenie
                                </Alert>
                            )}
                            {selectedDiscussionSupplierStatus === 'AGREED' && (
                                <Alert severity="success" variant="outlined" sx={{ py: 0.5, px: 1.5, fontSize: '0.85rem' }}>
                                    Dostawca: zatwierdził
                                </Alert>
                            )}
                        </Stack>
                    </Grid>

                    <Grid item xs={12} md="auto">
                        <Button
                            variant={selectedDiscussionSupplierStatus === 'AGREED' ? 'contained' : 'outlined'}
                            color={selectedDiscussionSupplierStatus === 'AGREED' ? 'success' : 'inherit'}
                            onClick={() =>
                                handleStatusChange(selectedDiscussionSupplierStatus === 'AGREED' ? null : 'AGREED')
                            }
                            startIcon={
                                selectedDiscussionSupplierStatus === 'AGREED' ? <CheckBox /> : <CheckBoxOutlineBlank />
                            }
                            size="medium"
                        >
                            {selectedDiscussionSupplierStatus === 'AGREED' ? (
                                <Localized id="status-agreed-confirmed">Zatwierdzono ustalenia</Localized>
                            ) : (
                                <Localized id="status-agreed">Zatwierdzam ustalenia</Localized>
                            )}
                        </Button>
                    </Grid>
                </Grid>
            </Paper> */}
            <LoadingButton loading={actionPending} onClick={handleNextClick}>
                <Localized id='next'>Dalej</Localized>
            </LoadingButton>
            <LoadingButton loading={actionPending} onClick={handleCloseClick}>
                <Localized id="close">
                    <span>Zamknij</span>
                </Localized>
            </LoadingButton>
        </DialogActions>
        {blobs &&
            <BlobPickerDialog
                open={blobPickerOpen}
                onClose={closeBlobPicker}
                blobs={blobs}
                selectedBlobId={selectedBlobId}
                onChangeSelectedBlob={handleChangeSelectedBlob}
            />
        }
    </Dialog>

}

const PublishOfferPanel = (props: { docId: string }) => {
    const { docId } = props
    const dispatch = useAppDispatch()

    const [accessRequests, setAccessRequests] = useState<PubAccessRequest[]>([])
    const [err, setErr] = useState<APIError | null>(null)

    useEffect(() => {
        const fetchData = async () => {
            try {

                const reqs = await dispatch(loadAccessRequests({
                    objectType: 'URS_OFFER',
                    objectId: docId,
                })).unwrap()
                setAccessRequests(reqs)
            } catch (err) {
                if (typeof err === 'object' && err !== null && err['name'] && err['name'] === 'ConditionError') {
                    // action cancelled
                } else {
                    dispatch(showError("error"))
                    setErr(err as APIError)
                }
            }
        }
        fetchData()
    }, [docId])

    const accessRequestDone = useCallback((id: string) => {
        setAccessRequests(rs => rs.filter(r => r.requestId !== id))
    }, [])

    return <Box gap={2}>
        {accessRequests.length > 0 && <Stack sx={{ mb: 1 }} gap={1}>
            {accessRequests.filter(a => a.status === 'Pending').map(a => <AccessRequest key={a.requestId} entity={a} done={accessRequestDone} />)}
        </Stack>}
        <ServerErrorMsg err={err} />
        <PublishLink objectId={docId} objectType="URS_OFFER" />
    </Box>
}

const AccessRequest = (props: { entity: PubAccessRequest, done: (reqId: string, approved: boolean) => void }) => {
    const { done } = props
    const dispatch = useAppDispatch()

    const [loading, setLoading] = useState(false)

    const handleAllowClick = async () => {
        try {
            setLoading(true)
            await dispatch(setStatusOfAccessRequest({
                requestId: entity.requestId,
                approve: true,
            })).unwrap()
            done(entity.requestId, true)
            dispatch(showSuccess('saved'))
        } catch (error) {
            console.log(error)
            dispatch(showError('error'))
        } finally {
            setLoading(false)
        }
    }

    const handleDenyClick = async () => {
        try {
            setLoading(true)
            await dispatch(setStatusOfAccessRequest({
                requestId: entity.requestId,
                approve: false,
            })).unwrap()
            done(entity.requestId, false)
            dispatch(showSuccess('saved'))
        } catch (error) {
            console.log(error)
            dispatch(showError('error'))
        } finally {
            setLoading(false)
        }
    }

    const { entity } = props
    return <Paper sx={{
        bgcolor: 'var(--gray-100)',
        border: '1px solid var(--gray-400)',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 2,
        p: 1,
    }}>
        <Box>Access request from email <Typography sx={{ color: 'var(--purple-600)' }} component='span'>{entity.email}</Typography></Box>
        <LoadingButton loading={loading} onClick={handleAllowClick} startIcon={<LoginIcon />} variant='contained' color='success'>
            <Localized id='publish-doc-allow-access'>Udostępnij</Localized>
        </LoadingButton>
        <LoadingButton loading={loading} onClick={handleDenyClick} startIcon={<BlockIcon />} variant='contained' color='error'>
            <Localized id='publish-doc-deny-access'>Odmów</Localized>
        </LoadingButton>
    </Paper>
}

const SendToEvaluateDialog = (props: { documentId: AppId, ok: (msg: string) => void, cancel: () => void }) => {
    const { ok, cancel } = props
    const [offerComment, setOfferComment] = useState("")

    const handleOfferCommentChange: AppTextFieldHandler = useCallback(e => setOfferComment(e.target.value), [])
    type Step = "choose" | "link" | "email";

    const handleConfirmSendToEvaluateClick = () => ok(offerComment)
    const [step, setStep] = useState<Step>("choose");

    return (
        <Dialog open={true} maxWidth="md" fullWidth>
            <DialogTitle>
                <span>The company is not registered in the system</span>
            </DialogTitle>

            <DialogContent>
                {step === "choose" && (
                    <>
                        <Alert severity="info" sx={{ mb: 2 }}>
                            <span>
                                This company does not have an account in our system. How would
                                you like to share the evaluation request?
                            </span>
                        </Alert>
                        <Box display="flex" flexDirection="column" gap={2}>
                            <Button variant="outlined" onClick={() => setStep("link")}>
                                Use public link
                            </Button>
                        </Box>
                    </>
                )}

                {step === "link" && (
                    <Box>
                        <Typography gutterBottom>Copy and share the public link:</Typography>
                        <Box
                            display="flex"
                            alignItems="center"
                            sx={{ bgcolor: "grey.100", p: 1, borderRadius: 1 }}
                        >
                            <PublishLink objectId={props.documentId} objectType="URS_OFFER" />
                        </Box>
                    </Box>
                )}
            </DialogContent>

            <DialogActions>
                {step !== "choose" && (
                    <Button onClick={() => setStep("choose")}>Back</Button>
                )}
                <Button onClick={cancel}>Cancel</Button>
                {step === "email" && (
                    <Button variant="contained" onClick={handleConfirmSendToEvaluateClick}>
                        Send
                    </Button>
                )}
                {step === "link" && (
                    <Button variant="contained" onClick={() => ok("")}>
                        Mark as Under Evaluation
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
}
